import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AlertMessage from '../../AlertMessage';


                 
function DainandinNondvahi() {
  
  const language = localStorage.getItem("language");
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [day, setDay] = useState('');
  const [menu, setMenu] = useState({});
  const [praman, setPraman] = useState({});
  const [error, setError] = useState('');
  const [tableData, setTableData] = useState([]);
  const [labharthiValue, setLabharthiValue] = useState('');
  const [labharthiInput, setLabharthiInput] = useState('');
  const udiseNumber = localStorage.getItem("udiseNumber");

  const [alertMessage, setAlertMessage] = useState("");
const [showAlert, setShowAlert] = useState(false);
useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage(""); 
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  const navigate = useNavigate();
 
  const aaharMenuOptions = [
    { value: 'Vegetable Pulav', label: language === "English" ? 'Vegetable Pulav' : 'व्हेजिटेबल पुलाव' },
    { value: 'Masale Bhat', label: language === "English" ? 'Masala Rice' : 'मसाले भात' },
    { value: 'Matar Pulav', label: language === "English" ? 'Matar Pulav' : 'मटर पुलाव' },
    { value: 'Mungdal Khichadi', label: language === "English" ? 'Mungdal चवळी खिचडी' : 'मुगडाळ खिचडी' },
    { value: 'Chawali Khichadi', label: language === "English" ? 'Cowpea Khichadi' : 'चवळी खिचडी' },
    { value: 'Chana Pulav', label: language === "English" ? 'Chana Pulav' : 'चना पुलाव' },
    { value: 'Soyabin Pulav', label: language === "English" ? 'Soyabin Pulav' : 'सोयाबीन पुलाव' },
    { value: 'Masuri Pulav', label: language === "English" ? 'Masuri Pulav' : 'मसुरी पुलाव' },
    { value: 'Anda Pulav', label: language === "English" ? 'Egg Pulav' : 'अंडा पुलाव' },
    { value: 'Sprouted Matki Usal', label: language === "English" ? 'Sprouted Matki Usal' : 'मोड आलेल्या मटकीची उसळ' },
    { value: 'Sweet Khichadi', label: language === "English" ? 'Sweet Khichadi' : 'गोड खिचडी' },
    { value: 'Mug Shevaga Varan Bhat', label: language === "English" ? 'Mug Shevaga Varan Bhat' : 'मूग शेवगा वरण भात' },
    { value: 'Tandalachi Kheer', label: language === "English" ? 'Rice pudding' : 'तांदळाची खीर' },
    { value: 'Nachaniche Satv', label: language === "English" ? 'ragi porridge' : 'नाचणीचे सत्व' },
    { value: 'Mod Alele Kaddhany', label: language === "English" ? 'Sprouted pulses' : 'मोड आलेले कडधान्य' }
  ];
  const dayMapping = [
    { key: '1', label: language === "English" ? "Monday" : "सोमवार" },
    { key: '2', label: language === "English" ? "Tuesday" : "मंगळवार" },
    { key: '3', label: language === "English" ? "Wednesday" : "बुधवार" },
    { key: '4', label: language === "English" ? "Thursday" : "गुरुवार" },
    { key: '5', label: language === "English" ? "Friday" : "शुक्रवार" },
    { key: '6', label: language === "English" ? "Saturday" : "शनिवार" },
    { key: '7', label: language === "English" ? "Monday" : "सोमवार" }, // For second week
    { key: '8', label: language === "English" ? "Tuesday" : "मंगळवार" },
    { key: '9', label: language === "English" ? "Wednesday" : "बुधवार" },
    { key: '10', label: language === "English" ? "Thursday" : "गुरुवार" },
    { key: '11', label: language === "English" ? "Friday" : "शुक्रवार" },
    { key: '12', label: language === "English" ? "Saturday" : "शनिवार" },
  ];

  const dayNameToIndex = {
    "Sunday": 6,    // Sunday corresponds to index 6 in your dayMapping
    "Monday": 0,    // Monday corresponds to index 0
    "Tuesday": 1,   // Tuesday corresponds to index 1
    "Wednesday": 2, // Wednesday corresponds to index 2
    "Thursday": 3,  // Thursday corresponds to index 3
    "Friday": 4,    // Friday corresponds to index 4
    "Saturday": 5   // Saturday corresponds to index 5
  };


  const classOptions = [
    { value: '1 To 5', label: language === "English" ? '1 to 5' : '१ ते ५' },
  { value: '6 To 8', label: language === "English" ? '6 to 8' : '६ ते ८' },
  ];
  useEffect(() => {
    if (selectedClass && selectedDate && udiseNumber) {
      const fetchData = async () => {
        try {
         const dateObj = new Date(selectedDate);
const year = dateObj.getFullYear();
const month = dateObj.getMonth(); // 0-indexed

// Find the first day of the month
const firstDay = new Date(year, month, 1);
const firstDayWeekday = firstDay.getDay(); // 0=Sunday, 1=Monday, ...

// Calculate the first Monday of this month
let firstMonday;
if (firstDayWeekday === 1) {
  firstMonday = 1;
} else if (firstDayWeekday === 0) {
  // if month starts on Sunday, Monday is on 2nd
  firstMonday = 2;
} else {
  firstMonday = 8 - firstDayWeekday + 1; // moves to the next Monday
}

const dayOfMonth = dateObj.getDate();
const dayOfWeek = dateObj.toLocaleString('en-US', { weekday: 'long' });
const dayIndex = dateObj.getDay(); // 0-6

// Determine the week based on firstMonday
let weekLabel;
if (dayOfMonth < firstMonday + 7) {
  weekLabel = 'firstWeek';
} else {
  weekLabel = 'secondWeek';
}

// Adjusted index (for your Firebase structure)
let adjustedIndex;
if (weekLabel === 'firstWeek') {
  adjustedIndex = dayIndex;
} else {
  adjustedIndex = dayIndex + 6;
}

  
  
          // Update the URLs with the correct structure
          const menuUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/menu/${weekLabel}/${adjustedIndex}.json`;
          const pramanUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/praman.json`;
          const labharthiUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/${selectedClass}/${year}/${month}/${dayOfWeek}/${dayOfMonth}.json`;
  
          
          const pramanResponse = await axios.get(pramanUrl);
          const pramanData = pramanResponse.data || {};
          const pramanValues = pramanData[selectedClass] || {};
  
          const menuResponse = await axios.get(menuUrl);
          const menuData = menuResponse.data || {};
  
          const labharthiResponse = await axios.get(labharthiUrl);
          const labharthiData = labharthiResponse.data || {};
  
          setPraman(pramanValues);
          setLabharthiValue(labharthiData);
          
          setLabharthiInput(labharthiData.labharthi || ''); 
          if (menuData) {
            setMenu(menuData);
            setError('');
  
// Prepare table data
const newTableData = Object.entries(menuData).flatMap(([menuName, content]) =>
  Object.entries(content).map(([menuContent, isSelected]) => {
    const pramanValue = parseFloat(pramanValues[menuContent]) || 0;
    const labharthiValue = labharthiData.labharthi || 0; // Ensure labharthiValue is a number
    const totalValue = labharthiData[menuContent] || 0; // Ensure totalValue is a number
    return {
      menuContent,
      praman: pramanValue,
      labharthi: labharthiValue,
      total: totalValue > 0 ? (totalValue % 1 === 0 ? totalValue.toString() : parseFloat(totalValue).toFixed(6)) : totalValue, 
    };
  })
);

const groupedTableData = newTableData.reduce((acc, row) => {
  if (!acc[row.menuContent]) {
    acc[row.menuContent] = { ...row }; 
  } else {
    acc[row.menuContent].total = parseFloat(acc[row.menuContent].total) + parseFloat(row.total);
    acc[row.menuContent].praman = parseFloat(acc[row.menuContent].praman) + parseFloat(row.praman);
    acc[row.menuContent].labharthi = acc[row.menuContent].labharthi;
  }
  return acc;
}, {});


const finalTableData = Object.values(groupedTableData);
setTableData(finalTableData);
          } else {
            setMenu({});
            setError('No data available');
            setTableData([]);
          }
        } catch (error) {
          setMenu({});
          setPraman({});
          setError(' Failed to fetch data. Please check your input or try again later.');
          setTableData([]);
        }
      };
  
      fetchData();
    }
  }, [selectedClass, selectedDate, udiseNumber]);

  useEffect(() => {
    if (tableData.length > 0) {
      const updatedTableData = tableData.map(row => ({
        ...row,
        labharthi: parseFloat(labharthiInput) || row.labharthi,
        total: parseFloat(labharthiInput) * row.praman || 0
      }));
      setTableData(updatedTableData);
    }
  }, [labharthiInput]);


  const handleDateChange = (e) => {
    const dateValue = e.target.value;
    setSelectedDate(dateValue);
    const dateObj = new Date(dateValue);
    const dayOfWeek = dateObj.toLocaleDateString('en-US', { weekday: 'long' });

    const index = dayNameToIndex[dayOfWeek];

    const dayInMarathi = language === "English" ? dayOfWeek : dayMapping[index].label;
    setDay(dayInMarathi);

    const dayOfMonth = dateObj.getDate().toString().padStart(2, '0');
};
  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);
  };

  const handleLabharthiChange = (e) => {
    setLabharthiInput(e.target.value);
  };
  const handleSave = async () => {
    if(!selectedDate || !selectedClass  || !labharthiInput || Object.keys(menu).length <= 0){
      setAlertMessage("Please fill all fields");
      return ;
    }
    try {
      const dateObj = new Date(selectedDate);
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0"); 
      const dayOfMonth = dateObj.getDate().toString().padStart(2, "0");
      const dayOfWeek = dateObj.toLocaleString('en-US', { weekday: 'long' }); 
  
  
      const saveUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/${selectedClass}/${year}/${month}/${dayOfWeek}/${dayOfMonth}.json`;
  

const openingMonthYearUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/openingMonthyear/${selectedClass}.json`;
const openingMonthYearResponse = await axios.get(openingMonthYearUrl);
const openingMonthYearData = openingMonthYearResponse.data || {};
const month2 = dateObj.getMonth() + 1;
const existingMonth = openingMonthYearData.month2 || null;
const existingYear = openingMonthYearData.year || null;


if (existingMonth && existingYear) {
  const selectedMonthNum = month2;
  const existingMonthNum = parseInt(existingMonth, 10);
  const selectedYearNum = year;
  const existingYearNum = existingYear;


  if (selectedYearNum < existingYearNum || (selectedYearNum === existingYearNum && selectedMonthNum < existingMonthNum)) {
    await axios.put(openingMonthYearUrl, { month: selectedMonthNum, year, path: "dainandinnondani" });
  }
} else {
  await axios.put(openingMonthYearUrl, { month: month2, year, path: "dainandinnondani" });
}
      const existingResponse = await axios.get(saveUrl);
      const existingData = existingResponse.data || {};
  
      const newData = {};
      tableData.forEach((row) => {
        newData[row.menuContent] = row.total > 0 ? (row.total % 1 === 0 ? row.total.toString() : parseFloat(row.total).toFixed(6)) : row.total; 
      });
      newData.labharthi = labharthiInput;
      const updatedData = { ...existingData, ...newData };
  
      await axios.put(saveUrl, updatedData);
      setAlertMessage("Saved Successfully")
    } catch (error) {
      console.error('Failed to save data:', error);
    }
  };
const handleReport = () => {
  if (!selectedDate || !selectedClass) {
    setAlertMessage("Please select both date and class before generating the report.");
    return;
  }

  navigate('/dainandinNondreport', {
    state: { selectedDate, selectedClass }
  });
};

const handleReport2 = () => {
  if (!selectedDate || !selectedClass) {
    setAlertMessage("Please select both date and class before generating the report.");
    return;
  }

  navigate('/tandalachinondavahi', {
    state: { selectedDate, selectedClass }
  });
};
 const handleDelete = async () => {
  if (!selectedClass || !selectedDate || !udiseNumber) {
    console.error('Class, selected date, or UDISE number is missing.');
    return;
  }

  try {
    // Parse the selected date
    const dateObj = new Date(selectedDate);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const dayOfWeek = dateObj.toLocaleString('en-US', { weekday: 'long' });
    const dayOfMonth = dateObj.getDate().toString().padStart(2, "0");

// Construct the URL for the specific node you want to delete
const deleteUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/${selectedClass}/${year}/${month}/${dayOfWeek}/${dayOfMonth}.json`;

// Send DELETE request to remove the data for the selected class and day
await axios.delete(deleteUrl);

// Clear relevant state after deletion
setLabharthiValue('');
setLabharthiInput('');
setTableData([]);

setAlertMessage('Data deleted successfully!');
} catch (error) {
  console.error('Failed to delete data:', error);
}
};

  
  const containerStyle = {
    maxWidth: '800px',
    margin: '1% auto',
    padding: '30px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    borderRadius: '5px',
    backgroundColor: '#fff',
    border:'1px solid gray'
  };

  const inputStyle = {
    display: 'block',
    marginTop: '10px',
    width: '130px',
    maxWidth: '300px',
    height:'35px', 
    marginRight: '20px', 
    fontSize:'14px', 
    padding:'8px',
    borderRadius:'5px',
    border:'1px solid gray'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontSize:'14px'
  };

  const buttonStyle = {
    marginTop: '20px',
    padding: '8px 20px',
    fontSize: '14px',
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  };
  const buttonStyleDelete = {
    marginTop: '20px',
    padding: '8px 16px',
    fontSize: '14px',
    backgroundColor: 'red',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginLeft:'2%',
  };
  const buttonStyleReport= {
    marginTop: '20px',
    padding: '8px 16px',
    fontSize: '14px',
    backgroundColor: '#d4a017',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginLeft:'20px',
    right:'0',
    float:'right'
  }

  const tableStyle = {
    marginTop: '20px',
    width: '100%',
    borderCollapse: 'collapse'
  };

  const tableHeaderStyle = {
    backgroundColor: '#f2f2f2'
  };

  const tableCellStyle = {
    padding: '8px',
    border: '1px solid black'
  };

  const rowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '30px',
  };

  return (
    <div>
      {/* <Sidebar /> */}
      
 <AlertMessage message={alertMessage} show={showAlert}/>

 
      <div className='main-content-of-page'>
        <div style={containerStyle}>
          <h3 className='text-center mb-5' style={{ color:'#1B4332', fontWeight:'600'}}> {language === "English" ? "Daily register  " : "दैनंदिन नोंदवही"}</h3>

          <div style={rowStyle}>
            <div>
              <label htmlFor="date" style={labelStyle}>{language === "English" ? " Date " : "दिनांक"} :</label>
              <input
                type="date"
                id="date"
                name="date"
                value={selectedDate}
                onChange={handleDateChange}
                style={inputStyle}
              />
            </div>

            {/* Class Dropdown */}
            <div>
              <label htmlFor="class-select" style={labelStyle}>{language === "English" ? " Class " : "वर्ग "} :</label>
              <select
                id="class-select"
                value={selectedClass}
                onChange={handleClassChange}
                style={inputStyle}
              >
                <option value="" disabled>{language === "English" ? "Select Class " : "वर्ग निवडा"}</option>
                {classOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="day" style={labelStyle}> {language === "English" ? " Day " : "वार "} :</label>
              <input
                type="text"
                id="day"
                name="day"
                value={day}
                readOnly
                style={inputStyle}
              />
            </div>
          </div>

          <div style={rowStyle}>
                     
            <div>
  <label htmlFor="labharthiInput" style={labelStyle}>{language === "English" ? " Beneficiary " : "लाभार्थी "}:</label>
  <input
  type="number"
  id="labharthiInput"
  name="labharthiInput"
  value={labharthiInput}
  onChange={handleLabharthiChange}
  onInput={(e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, 8);
    }
  }}
  style={inputStyle}
/>

</div>
    <div>
  <label htmlFor="menu" style={labelStyle}> {language === "English" ? " Menu " : "मेनू "}:</label>
  <div >
    {Object.keys(menu).length > 0 ? (
      Object.entries(menu).map(([menuName, content]) => (
        <li style={{fontSize:'14px'}} key={menuName}>{language === "English" ? menuName : aaharMenuOptions.find(option => option.value === menuName)?.label}</li>
      ))
    ) : (
      <span style={{fontSize:'14px'}}>{language === "English" ? "No Menu Available" : "कोणतेही मेनू उपलब्ध नाही"}</span>
    )}
  </div>
</div>
          </div>
          <hr/>


          <button onClick={handleSave} style={buttonStyle}>Save</button>
          {tableData.length > 0 && (tableData[0] && tableData[0].labharthi) > 0 && ( 
            <button onClick={handleDelete} style={buttonStyleDelete}>Delete</button>
          )}
         
          <button style={buttonStyleReport} onClick={handleReport}>Report</button>
          <button style={buttonStyleReport} onClick={handleReport2}>Rice Report</button>

        
          <table style={tableStyle}>
            <thead style={tableHeaderStyle}>
              <tr>
                <th className='text-center fw-bold '  style={{...tableCellStyle, color: 'black'}}>{language === "English" ? " Menu Content " : "मेन्यू मधील धान्य"}</th>
                <th className='text-center fw-bold ' style={{...tableCellStyle, color: 'black'}}>{language === "English" ? " Quantity (In Gram)" : "प्रमाण (ग्रॅम मध्ये)"}</th>
                <th className='text-center fw-bold ' style={{...tableCellStyle, color: 'black'}}>{language === "English" ? " Beneficiary " : "लाभार्थी "}</th>
                <th className='text-center fw-bold' style={{...tableCellStyle, color: 'black'}}>{language === "English" ? " Total (In Gram)" : "एकूण (ग्रॅम मध्ये)"}</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td style={tableCellStyle}>{row.menuContent}</td>
                  <td style={tableCellStyle}>{row.praman}</td>
                  <td style={tableCellStyle}>{labharthiInput}</td>
                  <td style={tableCellStyle}>
        {row.total > 0 
          ? (row.total % 1 === 0 ? row.total.toString() : parseFloat(row.total).toFixed(6)) 
          : row.total}
      </td>

                </tr>
              ))}
              <tr >
                <td style={{ padding: '18px' }}></td><td></td><td></td><td></td>
              </tr> <tr >
                <td style={{ padding: '18px' }}></td><td></td><td></td><td></td>
              </tr> <tr >
                <td style={{ padding: '18px' }}></td><td></td><td></td><td></td>
              </tr>
            </tbody>
          </table>

          {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
      </div>
    </div>
  );
}

export default DainandinNondvahi;